import { Button } from "@bphxd/ds-core-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircleCheck48} from '@bphxd/ds-core-react/lib/icons';
import './ContinuationPage.scss'
import { useUser } from "../../../contexts/userContextApi";
const ContinuationPage: React.FC = () => {
    const navigate = useNavigate();
   const {setIsAuthorize} =useUser()
    const handleContinue = () => {
        navigate('/drn/uploadDrn');
    };
useEffect(()=>{
    setIsAuthorize(true)
    console.log('hii',setIsAuthorize(true))
},[])
    return (
        <> <div className="container">
           <div  className='circlecheck' ><CircleCheck48 className="text-success"/></div> 
            <p>Information has been successfully updated</p>
            <Button
                level="primary"
                rounded="pill"
                size="lg"
                theme="brand"
                onClick={handleContinue}
            >
                Continue
            </Button>
        </div>
        </>
    );
};

export default ContinuationPage;
